module.exports = __webpack_public_path__ + "img/right3.005a109a.png";